<div class="login">
    <div class="container mx-auto">
        <div class="form login-backoffice flex items-center justify-center h-[100vh] w-full">
            <form *ngIf="step === 'credentials'" class="w-1/2" [formGroup]="formLogin" (ngSubmit)="onLogin()">
                <div class="flex flex-col gap-8">
                    <div class="w-full">
                        <h1 class="text-center font-mono uppercase lg:text-4xl text-2xl text-white">Accedi</h1>
                    </div>
                    <div class="w-full">
                        <input type="text" pInputText placeholder="Username" formControlName="username" required />
                    </div>
                    <div class="w-full">
                        <p-password [toggleMask]="true" formControlName="password" placeholder="Password" [feedback]="false" class="w-full grid" autocomplete />
                    </div>
                    <button class="button p-3 w-full border border-[#ccc] font-medium" type="submit" [disabled]="!formLogin.valid">Accedi</button>
                </div>
            </form>

            <form *ngIf="step === 'otp'" class="w-1/2" [formGroup]="formOtp" (ngSubmit)="onOtp()">
                <div class="flex flex-col gap-8">
                    <div class="w-full">
                        <h1 class="text-center font-mono uppercase lg:text-4xl text-2xl text-white">Codice 2FA</h1>
                        <p class="text-center text-white/80 mt-2 text-sm">Inserisci il codice a 6 cifre dall’app autenticatore</p>
                    </div>
                    <div class="w-full">
                        <input type="text" pInputText inputmode="numeric" autocomplete="one-time-code" maxlength="6" placeholder="000000" formControlName="code" required />
                    </div>
                    <button class="button p-3 w-full border border-[#ccc] font-medium" type="submit" [disabled]="!formOtp.valid">Verifica</button>
                    <button type="button" class="text-white/80 text-sm underline" (click)="backToCredentials()">Torna al login</button>
                </div>
            </form>
        </div>
    </div>
</div>
